import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

interface IuseBreakPoints {
  isTouchScreen: boolean;
  isDesktopScreen: boolean;
}

function useBreakpoints(): IuseBreakPoints {
  const theme = useTheme();

  const isTouchScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const isDesktopScreen = useMediaQuery(theme.breakpoints.up('md'));

  return {
    isTouchScreen,
    isDesktopScreen,
  };
}

export default useBreakpoints;
